import { Group, Box, Text, ThemeIcon } from '@mantine/core';
import {
  UserPlus,
  CheckCircle,
  Users,
  Briefcase,
  FileText,
  Calendar,
  RefreshCw,
  Settings,
  Activity,
  Mail,
} from 'react-feather';
import type { OverviewActivityEvent } from '../../../../types';
import { ACTIVITY_TYPE_CONFIG } from '../../../../config/overviewConfig';
import { formatDistanceToNow } from 'date-fns';

interface ActivityItemProps {
  activity: OverviewActivityEvent;
}

const ICON_MAP: Record<string, React.ComponentType<{ size?: number }>> = {
  'user-plus': UserPlus,
  'check-circle': CheckCircle,
  users: Users,
  briefcase: Briefcase,
  'file-text': FileText,
  calendar: Calendar,
  'refresh-cw': RefreshCw,
  settings: Settings,
  mail: Mail,
};

const DEFAULT_CONFIG = { label: 'Activity', color: 'gray', icon: 'activity' } as const;

export function ActivityItem({ activity }: ActivityItemProps) {
  const config = ACTIVITY_TYPE_CONFIG[activity.type] ?? DEFAULT_CONFIG;
  const IconComponent = ICON_MAP[config.icon] ?? Activity;

  const timeAgo = formatDistanceToNow(new Date(activity.timestamp), {
    addSuffix: true,
  });

  return (
    <Group gap="sm" py="xs" wrap="nowrap" align="flex-start">
      <ThemeIcon size={28} radius="xl" variant="light" color={config.color}>
        <IconComponent size={14} />
      </ThemeIcon>
      <Box style={{ flex: 1, minWidth: 0 }}>
        <Text size="sm" style={{ lineHeight: 1.4 }}>
          {activity.description}
        </Text>
        <Text size="xs" c="dimmed" mt={2}>
          {timeAgo}
          {activity.actorName && ` by ${activity.actorName}`}
        </Text>
      </Box>
    </Group>
  );
}

export default ActivityItem;
